import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var StyledListWrapper = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n"], ["\n    margin: 0;\n    padding: 0;\n"])));
var templateObject_1;
